import { FormErrors } from 'redux-form'
import i18next from 'i18next'
import { isEmail } from '../../../utils/helpers'

// eslint-disable-next-line import/no-cycle
import { IForgotPasswordForm } from './ForgotPasswordForm'

/**
 * @param {IForgotPasswordFrom} values
 */
export default (values: any) => {
	const errors: FormErrors<IForgotPasswordForm> = {}

	if (!values?.email) {
		errors.email = i18next.t('loc:This field is required')
	} else if (!isEmail(values.email)) {
		errors.email = i18next.t('loc:Email format is incorrect')
	} else if (values.email?.length > 255) {
		errors.email = i18next.t('loc:Max. number of characters is {{max}}', { max: 255 })
	}

	return errors
}
